<div appModal (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">{{ isEditMode ? 'Edit event' : 'Add event' }}</div>
    <div class="modal--tabs" *ngIf="isEditMode">
      <button
        class="btn btn-lg btn-text"
        [class.selected]="viewType === MODAL_TYPES.SELECT"
        [class.disabled]="viewType !== MODAL_TYPES.SELECT && isEditMode"
        (click)="selectType($event, MODAL_TYPES.SELECT)"
        translate
      >
        SHARED.MODAL.USER_EVENT_MODAL.SELECT
      </button>
      <button
        class="btn btn-lg btn-text"
        [class.selected]="viewType === MODAL_TYPES.ADD"
        [class.disabled]="viewType !== MODAL_TYPES.ADD && isEditMode"
        (click)="selectType($event, MODAL_TYPES.ADD)"
        translate
      >
        SHARED.MODAL.USER_EVENT_MODAL.ADD_EVENT
      </button>
    </div>
  </section>

  <form [formGroup]="userEventForm">
    <section class="modal-content-container">
      <div *ngIf="viewType === MODAL_TYPES.SELECT">
        <label class="input-title required">Event</label>
        <ng-select
          [items]="eventsList$ | async"
          bindLabel="name"
          bindValue="id"
          formControlName="eventId"
          placeholder="Event"
          [minTermLength]="3"
          typeToSearchText="Please enter 3 or more characters"
          [loading]="eventLoading"
          [typeahead]="eventInput$"
          notFoundText="No events found"
          (change)="onEventSelect($event)"
          appendTo="body"
          class="normal-white"
        >
          <ng-template ng-loadingspinner-tmp>
            <div class="loader mr-5">
              <div class="ball1"></div>
              <div class="ball2"></div>
              <div class="ball3"></div>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div *ngIf="viewType === MODAL_TYPES.ADD">
        <label class="input-title required">Event name</label>
        <div class="input input-text" [class.input-error]="fhs.isInputInvalid(userEventForm, 'eventName')">
          <input type="text" formControlName="eventName" placeholder="Event name" />
        </div>
      </div>

      <div *ngIf="viewType === MODAL_TYPES.ADD" class="city-state mt-16">
        <div>
          <label class="input-title">City</label>
          <div class="input input-text" [class.input-error]="fhs.isInputInvalid(userEventForm, 'city')">
            <input type="text" formControlName="city" placeholder="City" />
          </div>
        </div>
        <div>
          <label class="input-title">State</label>
          <div class="input input-text" [class.input-error]="fhs.isInputInvalid(userEventForm, 'state')">
            <input type="text" formControlName="state" placeholder="State" />
          </div>
        </div>
      </div>

      <div *ngIf="viewType === MODAL_TYPES.ADD" class="mt-16">
        <label class="input-title required">Event date</label>
        <div class="input input-text max-w-176" [class.input-error]="fhs.isInputInvalid(userEventForm, 'eventDate')">
          <input appDateFormat type="text" formControlName="eventDate" placeholder="MM/DD/YY" />
        </div>
      </div>

      <div class="mt-16">
        <label class="input-title">Team name</label>
        <div class="input input-text" [class.input-error]="fhs.isInputInvalid(userEventForm, 'teamName')">
          <input type="text" formControlName="teamName" placeholder="Team name" />
        </div>
      </div>

      <div class="mt-16">
        <label class="input-title">Jersey number</label>
        <div
          class="input input-text"
          [class.input-error]="fhs.isInputInvalid(userEventForm, 'jerseyNo')"
          [class.max-w-176]="viewType === MODAL_TYPES.ADD"
        >
          <input type="text" formControlName="jerseyNo" placeholder="Jersey number" />
        </div>
      </div>
    </section>
  </form>

  <div *ngIf="summaryErrorMessage" class="flex justify-center items-center text-sienna">
    {{ summaryErrorMessage }}
  </div>

  <section class="modal-actions-container">
    <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
    <button alt="Submit" class="btn btn-lg" (click)="onSubmit($event)">
      {{ isEditMode ? 'Edit Event' : 'Add Event' }}
    </button>
  </section>
</div>
